import { api } from "../../../shared/services/api";

export interface EventsByMonth {
  month: string;
  count: number;
}
export interface EventStatistics {
  eventId: number;
  eventTitle: string;
  participantsCount: number;
  totalAmount: number;
}

export interface StatisticsResponse {
  totalParticipants: number;
  totalEvents: number;
  totalOrganizers: number;
  participantsByEvent: EventStatistics[];
  eventsByMonth: EventsByMonth[];
}

export const statisticsService = {
  getStatistics: async (): Promise<StatisticsResponse> => {
    const response = await api.get('/statistics');
    return response.data;
  },
};